export default "__VITE_ASSET__ChKTLG5w__"